import { ResourceOptions } from 'react-admin';
import { FaUserCircle } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingAvatarDefaults;
export const icon = FaUserCircle;
export const options: ResourceOptions = {
  label: 'module.socialTrading.avatarDefaults',
};
